var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke:#1f98df;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.16,110.6c0-10,0-20.07,0-30.1,0-1.09-.3-1.35-1.36-1.33-4.49.06-9,0-13.47,0a3.59,3.59,0,0,1-3-6.08Q73.49,53.59,88.58,34.06q4.13-5.33, 8.23-10.66c1.94-2.52,4.41-2.53,6.34,0l37.91,49.05c.87,1.12,1.84,2.19,1.56,3.78a3.44,3.44,0,0,1-3.57,3c-4.61,0-9.22,0-13.83,0-1.11,0-1.41.28-1.41,1.4q0,29.68, 0,59.35c0,3.44-1.32,4.76-4.76,4.76H80.73c-3.19,0-4.57-1.4-4.57-4.58Z",
    fill: "#123c7f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.59,129.23v44.3c0,2.75-2.73,5-6.09,5H36.5c-3.36,0-6.09-2.22-6.09-5v-44.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.81235b0df4b2109c52e458c4f90885a3.svg";
export { ForwardRef as ReactComponent };